export enum VAT_DESCRIPTION {
    NONE = '-',
    WITH_VAT = 'withVat',
    WITHOUT_VAT = 'withoutVat',
    INCLUDING_TAX = 'includingTax',
    EXCLUDING_TAX = 'excludingTax',
}
